

































































import Vue from 'vue'
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { Ref } from "vue-property-decorator";
import { getErrorMessage } from '@/utils/notify-helper';

@Component({components: {}})
export default class ChangePassword extends Vue {
  @Ref("validator") validator: any;
  @Action("changePassword") actionChangePassword:any;
  @Action("forgotPasswordCheckLink") actionForgotPasswordCheckLink:any;
  @Action("forgotPasswordReset") actionForgotPasswordReset:any;

  private form = {
    newPassword: '',
    newPasswordAgain: '',
  }
  private isProgress: boolean = false;
  private errorMessage = '';
  private displayText = ''
  private token: string|(string|null)[] = ''

  get title() {
    return this.$store.getters.config.company + '<br>' + (this.token ? this.$t('auth.title') : this.$t('auth.changing_title'))
  }

  async created() {
    if (this.$route.query.token) {
      this.token = this.$route.query.token
      try {
        await this.actionForgotPasswordCheckLink({token: this.token})
      } catch(e) {
        this.displayText = getErrorMessage(e)
      }
    }
  }

  async changePassword() {
    this.errorMessage = ''
    if (!await this.validator.validate()) {
      if (this.validator.errors.new_password?.length) {
        for (let ec in this.validator.errors.new_password) {
          this.errorMessage += this.validator.errors.new_password[ec]
        }
      }
      if (this.validator.errors.confirm?.length) {
        for (let ec in this.validator.errors.confirm) {
          this.errorMessage += this.validator.errors.confirm[ec]
        }
      }
      setTimeout(() => this.errorMessage = '', 5000)
      return
    }

    this.isProgress = true;
    try {
      if (this.token) {
        await this.actionForgotPasswordReset({...this.form, token: this.token})
        this.$router.push('/login')
      } else {
        await this.actionChangePassword(this.form)
        this.$router.push(localStorage.getItem('lk-lastUrl') || '/')
      }
    } catch(e) {
      this.errorMessage = getErrorMessage(e)
    } finally {
      this.isProgress = false
    }
  }

  async doLogout() {
    await this.$store.dispatch('authLogout')
    this.$router.push('/login')
  }
}
